import clsx from "clsx";
import { useForm, UseFormRegisterReturn } from "react-hook-form";
import Button from "../../../student/components/generic/button";
import { ParentIcon } from "./ParentIcon";
import { LearnerIcon } from "./LearnerIcon";

interface FormInputs {
  accountType: "parent" | "learner";
}

const AccountTypeInput: React.FC<{
  value: FormInputs["accountType"];
  choice: FormInputs["accountType"];
  register: UseFormRegisterReturn<"accountType">;
}> = ({ value, choice, register }) => {
  return (
    <label
      htmlFor={`accountType-${choice}`}
      className={clsx(
        "flex h-[72px] w-full cursor-pointer items-center justify-center gap-3 rounded-2xl border-[3px] border-dm-brand-blue-100 bg-white font-serif text-lg font-bold text-dm-brand-blue-600 transition-colors",
        value === choice
          ? "border-dm-brand-blue-500"
          : "hover:border-dm-brand-blue-200"
      )}
    >
      <input
        className="hidden"
        type="radio"
        value={choice}
        id={`accountType-${choice}`}
        {...register}
      />
      {choice === "parent" ? (
        <>
          <ParentIcon />
          I&apos;m a Parent
        </>
      ) : (
        <>
          <LearnerIcon />
          I&apos;m a Learner
        </>
      )}
    </label>
  );
};

export const InviteChoooseAccountType: React.FC<{
  onSubmit: (accountType: "parent" | "learner") => void;
}> = ({ onSubmit }) => {
  const {
    register,
    watch,
    handleSubmit,
    formState: { errors },
  } = useForm<FormInputs>();

  const selectedAccountType = watch("accountType");
  const accountTypeRegister = register("accountType", {
    required: "Select an option to continue",
  });

  return (
    <form
      className="flex w-full flex-col gap-6"
      onSubmit={handleSubmit((d: FormInputs) => {
        onSubmit(d.accountType);
      })}
    >
      <div className="mb-2 flex flex-col gap-2 text-center">
        <h1 className="font-serif text-2xl font-bold text-dm-brand-blue-600">
          Welcome!
        </h1>
        <p className="font-serif text-lg font-bold">
          Are you a parent or a learner?
        </p>
      </div>
      <div className="mb-4 flex flex-col gap-3">
        <AccountTypeInput
          choice="parent"
          value={selectedAccountType}
          register={accountTypeRegister}
        />
        <AccountTypeInput
          choice="learner"
          value={selectedAccountType}
          register={accountTypeRegister}
        />
        {errors.accountType && (
          <span className="-mt-1 text-center text-sm text-dm-error-500">
            {errors.accountType.message}
          </span>
        )}
      </div>
      <Button className="w-full">Continue</Button>
    </form>
  );
};
